export class QuickQuoteRequest {
    notifyClient?: boolean;
    key: string;
    parentKey?: string;
    answers: { Key: string, Value: string }[];
    sourceUrl?: string;

    constructor(key: string, answers: { Key: string, Value: string }[], notifyClient: boolean = true) {
        this.key = key;
        this.answers = answers;
        this.notifyClient = notifyClient;
    }
}
